<template>
  <Card :title="name">
    <template v-for="(b, i) in selfSummary">
      <Field
        :key="i"
        v-if="b.name == '自我小结'"
        v-model="b.remark"
        :label="b.name"
        :readonly="readonly"
        placeholder="请输入内容"
        show-word-limit
        type="textarea"
        maxlength="3000"
        rows="2"
      />
      <Field
        v-else
        :key="i"
        v-model="b.remark"
        :label="b.name"
        :readonly="readonly"
        placeholder="请输入内容"
      />
    </template>
  </Card>
</template>
<script>
import { Field } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "SelfSummary",
  props: {
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "六、自我小结",
      selfSummary: [
        { name: "自我小结", number: null, type: 2, countWay: 0, remark: "" },
        { name: "签字", number: null, type: 2, countWay: 0, remark: "" },
        { name: "年月日", number: null, type: 2, countWay: 0, remark: "" }
      ]
    };
  },
  components: { Card, Field }
};
</script>
<style lang="scss"></style>
